export default __webpack_public_path__ + "static/media/palestrina PER STAMPA 1.d7a4a76d.png";